module.exports = __webpack_public_path__ + "img/features5.57639037.png";